import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

// Agrega los plugins
dayjs.extend(utc)
dayjs.extend(timezone)

// Configura la zona horaria por defecto a Guatemala
dayjs.tz.setDefault('America/Guatemala')

export default dayjs
